import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  movementRecordTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main
  },

  movementRecordContent: {
    paddingTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },

  loadingContiner: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center'
  }
}))
